//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.VehicleDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[0,"AnchorageLocation",1,0],[0,"Atl",1,0],[0,"BackAngleDbl",1,0],[1,"BackAngleDim",0,"Expression",0],[0,"BeltRouting",1,0],[1,"FloorHeightDim",0,"Expression",0],[0,"L1Limit",1,0],[0,"L2Limit",1,0],[0,"LowerArea",1,0],[0,"LowerLimit",1,0],[1,"SDimension",0,"Expression",0],[0,"SeatPosition",1,0],[0,"SeatType",1,0],[0,"SgrpPoint",1,"Point",0],[1,"SgrpXvalDim",0,"Expression",0],[1,"SgrpYvalDim",0,"Expression",0],[1,"SgrpZvalDim",0,"Expression",0],[0,"Standard",1,0],[0,"StringLimit1",1,0],[0,"StringLimit2",1,0],[0,"UpArea",1,0]],[[[],"J383Illu",{},0,0],[[],"J1369Illu",{},0,0],[[],"Ece14SafeIllu",{},0,0],[[],"Ece14Isofix",{},0,0],[[],"CreatePointWithBaseDataSGRPExpression",{R_:{tsgrp:"Point"}},0,0]],[]];
SPLM.Features.VehicleDesign.SeatBeltAnchorageBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.VehicleDesign.SeatBeltAnchorageBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.VehicleDesign.SeatBeltAnchorageBuilder.StandardTypes = Object.freeze({
    "J383SeatBeltAnchorage" : "J383SeatBeltAnchorage", "J1369ChildRestraintTetherStraps" : "J1369ChildRestraintTetherStraps", "BothJ383AndJ1369" : "BothJ383AndJ1369", "ECE14SafetyBeltAnchorage" : "ECE14SafetyBeltAnchorage", "Ece14isofix" : "Ece14isofix"});

SPLM.Features.VehicleDesign.SeatBeltAnchorageBuilder.UpperAreaType = Object.freeze({
    "Yes" : "Yes", "No" : "No"});

SPLM.Features.VehicleDesign.SeatBeltAnchorageBuilder.LowerAreaType = Object.freeze({
    "Yes" : "Yes", "No" : "No"});

SPLM.Features.VehicleDesign.SeatBeltAnchorageBuilder.AnchorageLocationTypes = Object.freeze({
    "VehicleStructure" : "VehicleStructure", "SeatAssembly" : "SeatAssembly"});

SPLM.Features.VehicleDesign.SeatBeltAnchorageBuilder.RoutingTypes = Object.freeze({
    "OutsideSeatThruSeatSpring" : "OutsideSeatThruSeatSpring", "ToAnchorage" : "ToAnchorage"});

SPLM.Features.VehicleDesign.SeatBeltAnchorageBuilder.SeatTypes = Object.freeze({
    "MovableFront" : "MovableFront", "MovableRear" : "MovableRear", "Fixed" : "Fixed"});

SPLM.Features.VehicleDesign.SeatBeltAnchorageBuilder.SeatPositionTypes = Object.freeze({
    "Left" : "Left", "Right" : "Right", "NotOutboard" : "NotOutboard"});

SPLM.Features.VehicleDesign.SeatBeltAnchorageBuilder.ATLType = Object.freeze({
    "Yes" : "Yes", "No" : "No"});

SPLM.Features.VehicleDesign.SeatBeltAnchorageBuilder.LowerLimitType = Object.freeze({
    "Length450" : "Length450", "Length500" : "Length500"});

SPLM.Features.VehicleDesign.SeatBeltAnchorageBuilder.LOneLimitType = Object.freeze({
    "Degree30And80" : "Degree30And80", "Degree50And70" : "Degree50And70"});

SPLM.Features.VehicleDesign.SeatBeltAnchorageBuilder.LTwoLimitType = Object.freeze({
    "Degree45And80" : "Degree45And80", "Degree50And70" : "Degree50And70"});

export default SPLM;